import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { ModulesEnum } from './shared/models/modules-enum.model';
import { AuthenticationService } from './core/authentication/authentication.service';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private authService: AuthenticationService,
        private router: Router
    ) { }

    /**
     * Valida se a rota é válida de acordo com a permissão necessária para acessar.
     * @param route Objeto com as informações da rota acessada pelo usuário.
     */
    canActivate(route: ActivatedRouteSnapshot) {
        if (this.authService.getToken()) {
            return combineLatest(
                this.hasPermission(ModulesEnum[route.data.permission]),
                this.authService.getIsStatementSigned(),
                (hasPermission, isStatementSigned) => {
                    return hasPermission && isStatementSigned;
                }
            );
        }
        this.router.navigate(['']);
        return false;
    }

    /**
     * Valida se o usuário tem permissão para acessar o conteúdo.
     * @param permission Permissão que o usuário precisa ter para acessar o conteúdo.
     */
    private hasPermission(permission: any): Observable<any> {
        return this.authService.IdentityPermissionAction.pipe(
            map(permissaoAcao => {
                return this.validatePermission(permissaoAcao, permission);
            })
        );
    }

    /**
     * Valida se o usuário possuí uma determinada permissão para acessar o conteúdo.
     * @param permissaoAcao Lista de permissões e ações do usuário logado.
     * @param permission Permissão que o usuário precisa ter para acessar o conteúdo.
     */
    private validatePermission(permissaoAcao: any, permission: any): boolean {
        return permissaoAcao.some(x => x.Permissao.IdPermissao === permission || permission === 0);
    }
}
